import { Injectable } from '@angular/core';

import { SearchService } from 'shared/search/search.service';
import { SearchModel } from 'shared/search/search.model';
import { MY_PRODUCTS } from 'shared/search/search-service-types';


@Injectable()
export class CurrentProductsSearchService extends SearchService {

  // extendable fields:
  searchModel: SearchModel = new SearchModel();
  serviceType = MY_PRODUCTS;
  idField = 'itemId';

  getSearchURI(brandId: string, searchModel: SearchModel): string {
    return `/items/${brandId}/working`;
  }

}
